import { RefreshCw, X } from 'lucide-react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { Button } from './UI';
import styles from './AppShell.module.css';

export function PwaUpdatePrompt() {
  const { needRefresh: [needRefresh, setNeedRefresh], offlineReady: [offlineReady, setOfflineReady], updateServiceWorker } = useRegisterSW();
  if (!needRefresh && !offlineReady) return null;
  return <div className={styles.updatePrompt} role="status" aria-live="polite">
    <div><strong>{needRefresh ? '新版本已准备好' : '离线缓存已就绪'}</strong><span>{needRefresh ? '刷新后使用最新分析与隐私规则。' : '已访问页面可在离线时继续打开。'}</span></div>
    {needRefresh && <Button primary onClick={() => void updateServiceWorker(true)}><RefreshCw size={14} />立即更新</Button>}
    <Button icon aria-label="关闭更新提示" onClick={() => { setNeedRefresh(false); setOfflineReady(false); }}><X size={14} /></Button>
  </div>;
}
